export const packageInfo = {
  version: '0.0.5', /// version leitura  (att front e back grande).(att front).(att back)
  author: 'TakaTI'
}
